import { Flex } from "@chakra-ui/react";

const Redeal = () => {
  return (
    <Flex
      bg="white"
      w={{ base: "150px", md: "200px" }}
      h={{ base: "55px", md: "70px" }}
      px={2}
      align="center"
      justify="center"
      textAlign="center"
      fontSize={{ base: "14px", md: "16px" }}
      fontFamily="Shantell Sans"
      borderRadius="10px"
    >
      Redeal in progress...
    </Flex>
  );
};
export default Redeal;
